module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-down-green-1b5f984c5e390316cec149d0b1b6716a.svg";